export class IsiComponentEvent {
    IsiName: string;

    constructor(name: string) {
        // <summary>
        // Représente un évènement composant
        // </summary>
        // <param name="name">Nom de l'évènement.</param>
        // <history>
        // LRAT-GBAU - 26/03/2014 : Gestion évènements ajax
        // <history>
        this.IsiName = name;
    }

    type() {
        return "PostBack";
    }
}

window.IsiComponentEvent = IsiComponentEvent;